<template>
  <div class="d-flex">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol  sm="12" lg="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Acount creater</h1>
                <p class="text-muted">Create/update account</p>

                <!-- user name -->
                <!--  -->
                <CInput
                  horizontal
                  :readonly="isEditMode"
                  label="User name"
                  placeholder="Username"
                  autocomplete="username"
                  v-model="user.username"
                  :addLabelClasses="'text-right'"
                >
                <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <!-- user role -->
                <CSelect
                horizontal
                label="User role"
                :options="roles"
                placeholder="Please set user role"
                :value.sync="user.role"
                :addLabelClasses="'text-right'"
                >
                <template #prepend-content><CIcon name="cil-user"/></template>
                </CSelect>

                <CSelect
                horizontal
                label="User status"
                :options="status"
                placeholder="Please set user status"
                :value.sync="user.status"
                :addLabelClasses="'text-right'"
                >
                <template #prepend-content><CIcon name="cil-user"/></template>
                </CSelect>

                <!-- user email -->
                <CInput
                  horizontal
                  label="Email"
                  placeholder="Email"
                  autocomplete="email"
                  v-model="user.email"
                  prepend="@"
                  :addLabelClasses="'text-right'"
                />
                <div class="d-flex justify-content-evenly">
                  <CButton v-if="isEditMode" type="button" shape="pill" color="info" class="w-100 mx-2" @click="handleUpdate">Update</CButton>
                  <CButton v-if="isEditMode" type="button" shape="pill" color="danger" class="w-100 mx-2" @click="handleReset">Reset</CButton>
                  <CButton v-if="isEditMode" type="button" shape="pill" color="danger" class="w-100 mx-2" @click="handleDelete">Delete</CButton>
                  <CButton v-if="!isEditMode" type="button" shape="pill" color="info" class="w-100 mx-2" @click="handleCreate">Create</CButton>
                  <CButton type="button" color="secondary" shape="pill" class="w-100 mx-2" @click="handleCancel">Cancel</CButton>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: [
        { value: "super", label: "super" },
        { value: "admin", label: "admin" },
        { value: "user", label: "user" },
        { value: "viewer", label: "viewer" },
      ],
      status: ['Active', 'Inactive', 'Pending', 'Banned'],
      userID: '',
      user: {
        id: 0,
        username: '',
        password: '',
        email: '',
        role: '',
        status: '',
      }
    }
  },
  created() {
    this.userID = this.$route.query.id
    if(this.userID) {
      // console.log('do get user detail for: ', this.userID)
      this.getUserDetail(this.userID);
    }
  },
  computed: {
    // Check if the route contains a parameter for edit mode
    isEditMode() {
      return !!this.$route.query.id;
    },
  },
  methods: {
    getUserDetail(id) {
      this.$request(`/api/user/${id}`).then(res =>{
        this.user = res.data.user
        // console.log('get user detail: ', this.user)
      })
    },
    handleCreate() {
      // console.log('create item: ', this.user)
      this.$swal.fire({
          title: "Tạo tài khoản mới?",
          showDenyButton: false,
          showCancelButton: true,  
      }).then((result) => {
          if (result.isConfirmed) {
            this.$request.post(
                '/api/user/register',
                this.user
            ).then(res => {
                if(res.data.status === 'success') {
                  this.$swal.fire({
                    icon: "success",
                    title: "Tạo tài khoản",
                    html: "Tạo tài khoản thành công,<br>" + res.data.message,
                    });
                  this.$router.go(-1);
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Tạo tài khoản",
                    html: "Tạo tài khoản: " + this.user.username +
                      "<br>thất bại: " + res.data.status,
                  });
                }
            })
          }
      });
    },
    handleUpdate() {
      // console.log('update item: ', this.user)
      this.$swal.fire({
          title: "Cập nhật tài khoản?",
          showDenyButton: false,
          showCancelButton: true,  
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.put(
              `/api/user/${this.user.username}`,
              this.user
          ).then(res => {
              if(res.data.status === 'success') {
                this.$swal.fire({
                  icon: "success",
                  title: "Cập nhật tài khoản",
                  text: "Cập nhật tài khoản: " + this.user.username + " thành công" ,
                  });
                this.$router.go(-1);
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Cập nhật tài khoản",
                  html: "Cập nhật tài khoản:  " + this.user.username +
                    "<br>lỗi: " + res.data.status,
                });
              }
          })
        }
      });
    },
    handleDelete() {
      // console.log("Deleting item with user:", this.user.username);
      this.$swal.fire({
          title: "Xóa tài khoản?",
          showDenyButton: false,
          showCancelButton: true,  
      }).then((result) => {
          if (result.isConfirmed) {
            this.$request.delete(`/api/user/${this.user.id}`).
            then(res => {
                if(res.data.status === 'success') {
                  this.$swal.fire({
                    icon: "success",
                    title: "Xóa tài khoản",
                    html: "Xóa tài khoản: " + this.user.username + " thành công" ,
                    });
                    this.$router.go(-1);
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Xóa tài khoản",
                    html: "Xóa tài khoản: " + this.user.username +
                    "<br> lỗi: " + res.data.status,
                    });
                }
            })
          }
      });
    },
    handleReset() {
      // console.log('reset password ', this.user.username)
      this.$swal.fire({
        title: "Lấy mật khẩu mới?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(
            '/api/user/resetpassword',
            this.user
          ).then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Lấy mật khẩu mới",
                html: "Lấy mật khẩu mới thành công, " + res.data.message,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Lấy mật khẩu mới",
                html: "Lấy mật khẩu mới: " + this.user.username +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    handleCancel() {
      this.$router.go(-1);
    },
  }
}
</script>
